import { render, staticRenderFns } from "./successOrder.vue?vue&type=template&id=9e54bada&scoped=true"
import script from "./successOrder.vue?vue&type=script&lang=js"
export * from "./successOrder.vue?vue&type=script&lang=js"
import style0 from "./successOrder.vue?vue&type=style&index=0&id=9e54bada&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e54bada",
  null
  
)

export default component.exports